import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { RecoveryService } from '../_services/recovery.service';

@Component({
    selector: 'app-emailRecovery',
    templateUrl: './emailRecovery.component.html',
    styleUrls: ['./emailRecovery.component.less'],
    standalone: false
})
export class EmailRecoveryComponent implements OnInit {

  constructor(private recovery: RecoveryService) { }

  email: string = "";

  ngOnInit() {
  }

  send() {
    if(this.email == "")
      return;
    this.recovery.recovery(this.email).subscribe(() => {
      document.location.href = "";
    });
  }

}
